export const COMMON_DETAIL = {
  sangjo: {
    title: "상조 서비스",
    isNotLocale: true,
    detailKey: ["유가족", "조문객"],
  },
  parlor: {
    title: "장례식장",
    detailKey: ["평수"],
  },
  crematorium: {
    title: "화장 시설 (1차 장지)",
    detailKey: ["구분"],
  },
  jangji: {
    title: "유골 안치 (2차 장지)",
    detailKey: ["구분"],
    detailValue: ["상담 필요"],
  },
};

export const SANGJO_DETAIL = {
  일반장: {
    ...COMMON_DETAIL.sangjo,
    name: "일반장",
    detailValue: ["8명 내외", "100명 이상"],
    sum: 3_500_000,
    results: {
      인력: {
        sum: 118,
        results: {
          "고이 장례지도사": {
            detail: "1명 (3일)",
            charge: 60,
          },
          "입관 보조 장례지도사": {
            detail: "1명 (1일)",
            charge: 10,
          },
          "접객 도우미": {
            detail: "2명 (2일)",
            charge: 48,
          },
        },
      },
      용품: {
        sum: 147,
        results: {
          관: {
            detail: "오동나무 특관",
            charge: 15,
          },
          "종교별 맞춤 수의": {
            detail: "저마 100%",
            charge: 36,
          },
          "종교별 맞춤 유골함": {
            detail: "일반 밀봉 진공함",
            charge: 50,
          },
          "관 장식용 생화": {
            detail: "계절별 생화 및 국화 안개",
            charge: 10,
          },
          "입관 용품": {
            detail: "위생용품, 관보 등 20여종",
            charge: 16,
          },
          상복: {
            detail: "남자 상복 4벌, 여자 상복 4벌",
            charge: 20,
          },
        },
      },
      차량: {
        sum: 85,
        results: {
          "1일차 고인 이송 차량": {
            detail: "앰뷸런스(관내)",
            charge: 10,
          },
          "3일차 장의 차량 (버스)": {
            detail: "45인승 버스",
            charge: 40,
          },
          "3일차 장의 차량 (리무진)": {
            detail: "리무진",
            charge: 35,
          },
        },
      },
      // 기타: {
      //   sum: undefined,
      //   results: {
      //     "고이 상주 키트": {
      //       detail: "세면 용품, 손수건 등",
      //       charge: undefined,
      //     },
      //   },
      // },
    },
  },

  가족장: {
    ...COMMON_DETAIL.sangjo,
    name: "가족장",
    detailValue: ["4명 내외", "100명 이하"],
    sum: 2_500_000,
    results: {
      인력: {
        sum: 94,
        results: {
          "고이 장례지도사": {
            detail: "1명 (3일)",
            charge: 60,
          },
          "입관 보조 장례지도사": {
            detail: "1명 (1일)",
            charge: 10,
          },
          "접객 도우미": {
            detail: "1명 (2일)",
            charge: 24,
          },
        },
      },
      용품: {
        sum: 106,
        results: {
          관: {
            detail: "오동나무 특관",
            charge: 15,
          },
          "종교별 맞춤 수의": {
            detail: "면 100%",
            charge: 20,
          },
          "종교별 맞춤 유골함": {
            detail: "황토함",
            charge: 35,
          },
          "관 장식용 생화": {
            detail: "계절별 생화 및 국화 안개",
            charge: 10,
          },
          "입관 용품": {
            detail: "위생용품, 관보 등 20여종",
            charge: 16,
          },
          상복: {
            detail: "남자 상복 2벌, 여자 상복 2벌",
            charge: 10,
          },
        },
      },
      차량: {
        sum: 50,
        results: {
          "1일차 고인 이송 차량": {
            detail: "앰뷸런스(관내)",
            charge: 10,
          },
          "3일차 장의 차량 (버스)": {
            detail: "45인승 버스",
            charge: 40,
          },
        },
      },
      // 기타: {
      //   sum: undefined,
      //   results: {
      //     "고이 상주 키트": {
      //       detail: "세면 용품, 손수건 등",
      //       charge: undefined,
      //     },
      //   },
      // },
    },
  },

  무빈소장: {
    ...COMMON_DETAIL.sangjo,
    name: "무빈소장",
    detailValue: ["4명 내외", "생략"],
    sum: 1_500_000,
    results: {
      인력: {
        sum: 55,
        results: {
          "고이 장례지도사": {
            detail: "1명 (3일)",
            charge: 45,
          },
          "입관 보조 장례지도사": {
            detail: "1명 (1일)",
            charge: 10,
          },
        },
      },
      용품: {
        sum: 45,
        results: {
          관: {
            detail: "오동나무 특관",
            charge: 15,
          },
          "종교별 맞춤 수의": {
            detail: "화장용 수의",
            charge: 10,
          },
          "종교별 맞춤 유골함": {
            detail: "목함",
            charge: undefined,
          },
          "관 장식용 생화": {
            detail: "계절별 생화 및 국화 안개",
            charge: 8,
          },
          "입관 용품": {
            detail: "위생용품, 관보 등 20여종",
            charge: 12,
          },
        },
      },
      차량: {
        sum: 50,
        results: {
          "1일차 고인 이송 차량": {
            detail: "앰뷸런스(관내)",
            charge: 10,
          },
          "3일차 장의 차량 (버스)": {
            detail: "45인승 버스",
            charge: 40,
          },
        },
      },
    },
  },
};

export const SANGJO_DETAIL_220807 = {
  일반장: {
    ...COMMON_DETAIL.sangjo,
    name: "일반장",
    detailValue: ["8명 내외", "100명 이상"],
    sum: 3_500_000,
    amountRange: [2_990_000, 4_400_000],
    results: {
      인력: {
        sum: 118,
        results: {
          "고이 장례지도사": {
            detail: "1명 (3일)",
            charge: 60,
          },
          "입관 보조 장례지도사": {
            detail: "1명 (1일)",
            charge: 10,
          },
          "접객 도우미": {
            detail: "2명 (2일)",
            charge: 48,
          },
        },
      },
      용품: {
        sum: 147,
        results: {
          관: {
            detail: "오동나무 특관",
            charge: 15,
          },
          "종교별 맞춤 수의": {
            detail: "저마 100%",
            charge: 36,
          },
          "종교별 맞춤 유골함": {
            detail: "일반 밀봉 진공함",
            charge: 50,
          },
          "관 장식용 생화": {
            detail: "계절별 생화 및 국화 안개",
            charge: 10,
          },
          "입관 용품": {
            detail: "위생용품, 관보 등 20여종",
            charge: 16,
          },
          상복: {
            detail: "남자 상복 4벌, 여자 상복 4벌",
            charge: 20,
          },
        },
      },
      차량: {
        sum: 85,
        results: {
          "1일차 고인 이송 차량": {
            detail: "앰뷸런스(관내)",
            charge: 10,
          },
          "3일차 장의 차량 (버스)": {
            detail: "45인승 버스",
            charge: 40,
          },
          "3일차 장의 차량 (리무진)": {
            detail: "리무진",
            charge: 35,
          },
        },
      },
      // 기타: {
      //   sum: undefined,
      //   results: {
      //     "고이 상주 키트": {
      //       detail: "세면 용품, 손수건 등",
      //       charge: undefined,
      //     },
      //   },
      // },
    },
  },

  가족장: {
    ...COMMON_DETAIL.sangjo,
    name: "가족장",
    detailValue: ["4명 내외", "100명 이하"],
    sum: 2_500_000,
    amountRange: [1_390_000, 2_600_000],
    results: {
      인력: {
        sum: 94,
        results: {
          "고이 장례지도사": {
            detail: "1명 (3일)",
            charge: 60,
          },
          "입관 보조 장례지도사": {
            detail: "1명 (1일)",
            charge: 10,
          },
          "접객 도우미": {
            detail: "1명 (2일)",
            charge: 24,
          },
        },
      },
      용품: {
        sum: 106,
        results: {
          관: {
            detail: "오동나무 특관",
            charge: 15,
          },
          "종교별 맞춤 수의": {
            detail: "면 100%",
            charge: 20,
          },
          "종교별 맞춤 유골함": {
            detail: "황토함",
            charge: 35,
          },
          "관 장식용 생화": {
            detail: "계절별 생화 및 국화 안개",
            charge: 10,
          },
          "입관 용품": {
            detail: "위생용품, 관보 등 20여종",
            charge: 16,
          },
          상복: {
            detail: "남자 상복 2벌, 여자 상복 2벌",
            charge: 10,
          },
        },
      },
      차량: {
        sum: 50,
        results: {
          "1일차 고인 이송 차량": {
            detail: "앰뷸런스(관내)",
            charge: 10,
          },
          "3일차 장의 차량 (버스)": {
            detail: "45인승 버스",
            charge: 40,
          },
          "3일차 장의 차량 (리무진)": {
            detail: "제공되지 않는 상품입니다",
            charge: "--",
          },
        },
      },
      // 기타: {
      //   sum: undefined,
      //   results: {
      //     "고이 상주 키트": {
      //       detail: "세면 용품, 손수건 등",
      //       charge: undefined,
      //     },
      //   },
      // },
    },
  },

  무빈소장: {
    ...COMMON_DETAIL.sangjo,
    name: "무빈소장",
    detailValue: ["4명 내외", "생략"],
    sum: 1_500_000,
    amountRange: [990_000, 1_600_000],
    results: {
      인력: {
        sum: 55,
        results: {
          "고이 장례지도사": {
            detail: "1명 (3일)",
            charge: 45,
          },
          "입관 보조 장례지도사": {
            detail: "1명 (1일)",
            charge: 10,
          },
          접객도우미: {
            detail: "제공되지 않는 상품입니다",
            charge: "--",
          },
        },
      },
      용품: {
        sum: 45,
        results: {
          관: {
            detail: "오동나무 특관",
            charge: 15,
          },
          "종교별 맞춤 수의": {
            detail: "화장용 수의",
            charge: 10,
          },
          "종교별 맞춤 유골함": {
            detail: "목함",
            charge: undefined,
          },
          "관 장식용 생화": {
            detail: "계절별 생화 및 국화 안개",
            charge: 8,
          },
          "입관 용품": {
            detail: "위생용품, 관보 등 20여종",
            charge: 12,
          },
          상복: {
            detail: "제공되지 않는 상품입니다",
            charge: "--",
          },
        },
      },
      차량: {
        sum: 50,
        results: {
          "1일차 고인 이송 차량": {
            detail: "앰뷸런스(관내)",
            charge: 10,
          },
          "3일차 장의 차량 (버스)": {
            detail: "45인승 버스",
            charge: 40,
          },
          "3일차 장의 차량 (리무진)": {
            detail: "제공되지 않는 상품입니다",
            charge: "--",
          },
        },
      },
    },
  },
};

export const SANGJO_DEDUCTION = {
  일반장: [
    "2일장(1박 2일)으로 장례식을 치를 경우 장례지도사 인건비 15만원을 공제해드립니다.",
    "접객 도우미의 근로 시간이 32시간 미만일 경우 시간당 1.5만원을 공제해드립니다. 분 단위는 절삭하여 계산합니다.",
    "수의를 사용하지 않을 경우 36만원을 공제해드립니다.",
    "유골함을 사용하지 않을 경우 50만원을 공제해드립니다. 일반 밀봉 진공함이 아닌 황토함으로 변경할 경우 15만원을 공제해드립니다.",
    "상복을 입지 않을 경우 20만원을 공제해드립니다. 남자 상복 1벌당 4만원, 여자 상복 1벌당 1만원의 비용이 공제됩니다.",
    "앰뷸런스를 이용하지 않을 경우 10만원을 공제해드립니다.",
    "장의 차량 중 1대만 이용하실 경우 35만원을 공제해드립니다.",
  ],
  가족장: [
    "2일장(1박 2일)으로 장례식을 치를 경우 장례지도사 인건비 15만원을 공제해드립니다.",
    "접객 도우미의 근로 시간이 16시간 미만일 경우 시간당 1.5만원을 공제해드립니다. 분 단위는 절삭하여 계산합니다.",
    "수의를 사용하지 않을 경우 20만원을 공제해드립니다.",
    "유골함을 사용하지 않을 경우 35만원을 공제해드립니다.",
    "상복을 입지 않을 경우 10만원을 공제해드립니다. 남자 상복 1벌당 4만원, 여자 상복 1만원의 비용이 공제됩니다.",
    "앰뷸런스를 이용하지 않을 경우 10만원을 공제해드립니다.",
  ],
  무빈소장: [
    "2일장(1박 2일)으로 장례식을 치를 경우 장례지도사 인건비 10만원을 공제해드립니다.",
    "수의를 사용하지 않을 경우 10만원을 공제해드립니다.",
    "앰뷸런스를 이용하지 않을 경우 10만원을 공제해드립니다.",
  ],
};

export const SANGJO_EXTRA = {
  일반장: [
    "아래와 같은 특수한 경우가 아니라면, 비용을 별도로 청구하지 않습니다. <b>만약 추가적인 서비스 구매를 유도한다면 상조 서비스 금액을 전액 환불해드립니다.</b>",
    "4일장(3박 4일) 또는 5일장(4박 5일)으로 장례식을 치를 경우 장례지도사 인건비가 1일당 15만원씩 추가적으로 발생합니다.",
    "32시간을 초과하여 접객 도우미가 필요하실 경우 접객 도우미 인건비가 시간당 1.5만원씩 추가적으로 발생합니다.",
    "서비스에 포함된 수의보다 가격이 높은 수의를 먼저 요청하신 경우에 한해 수의 카탈로그를 보여드립니다. 더 높은 금액의 수의를 구매하실 경우 기존 수의 가격(36만원)에서 차액만 청구합니다.",
    "서비스에 포함된 유골함보다 가격이 높은 유골함을 먼저 요청하신 경우에 한해 유골함 카탈로그를 보여드립니다. 더 높은 금액의 유골함을 구매하실 경우 기존 유골함 가격(50만원)에서 차액만 청구합니다.",
    "상복이 추가적으로 필요할 경우 남자 상복 1벌당 4만원, 여자 상복 1벌당 1만원의 비용이 추가적으로 발생합니다.",
    // "고이 상주 키트가 9개 이상 필요할 경우 상주 키트 구매 비용이 1개당 1만원씩 추가적으로 발생합니다.",
    "익살, 자살 등 사고사의 경우 특수처리비가 20만원 ~ 60만원 추가적으로 발생할 수 있습니다.",
    "1일차 고인 이송 차량의 경우 관외 지역으로 분류되면 10만원 이상의 추가적인 비용이 발생할 수 있습니다.",
    "3일차 장의 차량의 경우 200km를 초과하여 운행할 경우 운임비가 1km당 2,000원씩 추가적으로 발생합니다.",
    "화장이 아닌 매장을 선택하실 경우 매장용 관, 수의가 필요함에 따라 상조 서비스의 10~20%에 해당하는 비용이 추가적으로 발생합니다.",
  ],
  가족장: [
    "아래와 같은 특수한 경우가 아니라면, 비용을 별도로 청구하지 않습니다. <b>만약 추가적인 서비스 구매를 유도한다면 상조 서비스 금액을 전액 환불해드립니다.</b>",
    "4일장(3박 4일) 또는 5일장(4박 5일)으로 장례식을 치를 경우 장례지도사 인건비가 1일당 15만원씩 추가적으로 발생합니다.",
    "16시간을 초과하여 접객 도우미가 필요하실 경우 접객 도우미 인건비가 시간당 1.5만원씩 추가적으로 발생합니다.",
    "서비스에 포함된 수의보다 가격이 높은 수의를 먼저 요청하신 경우에 한해 수의 카탈로그를 보여드립니다. 더 높은 금액의 수의를 희망하실 경우 기존 수의 가격(20만원)에서 차액만 청구합니다.",
    "서비스에 포함된 유골함보다 가격이 높은 유골함을 먼저 요청하신 경우에 한해 유골함 카탈로그를 보여드립니다. 더 높은 유골함을 구매하실 경우 기존 유골함 가격(35만원)에서 차액만 청구합니다.",
    "상복이 추가적으로 필요한 경우 남자 상복 1벌당 4만원, 여자 상복 1벌당 1만원의 비용이 추가적으로 발생합니다.",
    "리무진을 추가로 이용하실 경우 리무진 대여료(편도)가 35만원이 추가적으로 발생합니다.",
    // "고이 상주 키트가 5개 이상 필요할 경우 상주 키트 구매 비용이 1개당 1만원씩 추가적으로 발생합니다.",
    "익살, 자살 등 사고사의 경우 특수처리비가 20만원 ~ 60만원 추가적으로 발생할 수 있습니다.",
    "1일차 고인 이송 차량의 경우 관외 지역으로 분류되면 10만원 이상의 추가적인 비용이 발생할 수 있습니다.",
    "3일차 장의 차량의 경우 200km를 초과하여 운행할 경우 운임비가 1km당 2,000원씩 추가적으로 발생합니다.",
    "화장이 아닌 매장을 선택하실 경우 매장용 관, 수의가 필요함에 따라 상조 서비스의 10~20%에 해당하는 비용이 추가적으로 발생합니다.",
  ],
  무빈소장: [
    "아래와 같은 특수한 경우가 아니라면, 비용을 별도로 청구하지 않습니다. <b>만약 추가적인 서비스 구매를 유도한다면 상조 서비스 금액을 전액 환불해드립니다.</b>",
    "4일장(3박 4일) 또는 5일장(4박 5일)으로 장례식을 치를 경우 장례지도사 인건비가 1일당 10만원씩 추가적으로 발생합니다.",
    "서비스에 포함된 수의보다 가격이 높은 수의를 먼저 요청하신 경우에 한해 수의 카탈로그를 보여드립니다. 구매를 희망하실 경우 차액(10만원 공제)만큼 추가적으로 비용이 발생합니다.",
    "서비스에 포함된 유골함보다 가격이 높은 유골함을 먼저 요청하신 경우에 한해 유골함 카탈로그를 보여드립니다. 구매를 희망하실 경우 유골함 가격만큼 추가적으로 비용이 발생합니다.",
    "상복이 필요할 경우 상복 1벌당 4만원, 여자 상복 1벌당 1만원의 비용이 추가적으로 발생합니다.",
    "리무진을 추가로 이용하실 경우 리무진 대여료(편도)가 35만원이 추가적으로 발생합니다.",
    "익살, 자살 등 사고사의 경우 특수처리비가 20만원 ~ 60만원 추가적으로 발생할 수 있습니다.",
    "1일차 고인 이송 차량의 경우 관외 지역으로 분류되면 10만원 이상의 추가적인 비용이 발생할 수 있습니다.",
    "3일차 장의 차량의 경우 200km를 초과하여 운행할 경우 운임비가 1km당 2,000원씩 추가적으로 발생합니다.",
    "화장이 아닌 매장을 선택하실 경우 매장용 관, 수의가 필요함에 따라 상조 서비스의 10~20%에 해당하는 비용이 추가적으로 발생합니다.",
  ],
};
